(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-details-link"] && !Shopify.designMode) return;
  try {
    (() => {
    const followCard = (event) => {
      if (event.defaultPrevented || event.altKey) return;
      if (event.type === 'click' && event.button !== 0) return;
      if (event.type === 'auxclick' && event.button !== 1) return;

      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      const card = target?.closest('.prod[data-product-id]');
      if (!card) return;

      const control = target.closest('a, button, input, select, textarea, label, summary, video, audio, iframe, [role="button"], [role="link"], [contenteditable], [tabindex]');
      if (control && control !== card && card.contains(control)) return;

      const selection = window.getSelection();
      if (selection && !selection.isCollapsed) return;

      const destination = card.querySelector('.og-card-master__btn[href]')
        || card.querySelector('.prod-name[href*="/products/"]')
        || card.querySelector('.prod-img[href*="/products/"]');
      if (!destination || !destination.getAttribute('href')?.includes('/products/')) return;

      event.preventDefault();
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.button === 1) {
        window.open(destination.href, '_blank', 'noopener');
      } else {
        destination.click();
      }
    };

    const enhance = (details) => {
      const summary = details.querySelector('.og-card-master__summary');
      if (!summary || summary.closest('a')) return;

      const card = details.closest('.og-master-card-host');
      if (!card) return;

      const destination = details.querySelector('.og-card-master__btn[href]')
        || card.querySelector('a[href*="/products/"]');
      const href = destination?.getAttribute('href');
      if (!href || !href.includes('/products/')) return;

      const stars = details.querySelector('.og-card-master__stars');
      const interactive = 'a, button, input, select, textarea, [role="button"], [contenteditable]';
      if (summary.querySelector(interactive) || stars?.querySelector(interactive)) return;

      const link = document.createElement('a');
      link.className = 'mr-product-details-link';
      link.setAttribute('href', href);

      const title = card.querySelector('.prod-name')?.textContent.trim();
      if (title) link.setAttribute('aria-label', title);

      details.insertBefore(link, stars || summary);
      const ratingSlot = document.createElement('div');
      ratingSlot.className = 'mr-product-rating-slot';
      if (stars) {
        ratingSlot.append(stars);
      } else {
        ratingSlot.setAttribute('aria-hidden', 'true');
      }
      link.append(ratingSlot);
      link.append(summary);
    };

    const scan = (root) => {
      if (root !== document && !(root instanceof Element)) return;
      if (root.matches?.('.og-card-master')) enhance(root);
      root.querySelectorAll('.og-card-master').forEach(enhance);
    };

    const start = () => {
      if (document.documentElement.dataset.mrCardDetailsLinks === 'ready') return;
      document.documentElement.dataset.mrCardDetailsLinks = 'ready';

      document.addEventListener('click', followCard);
      document.addEventListener('auxclick', followCard);

      scan(document);
      const observer = new MutationObserver((records) => {
        for (const record of records) {
          for (const node of record.addedNodes) scan(node);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["selector-pais-header"] && !Shopify.designMode) return;
  try {
    /* CERRAR SELECTOR AL HACER CLIC FUERA */

  document.addEventListener('click', function (event) {
    document
      .querySelectorAll('.mr-country-header__disclosure[open]')
      .forEach(function (disclosure) {
        if (!disclosure.contains(event.target)) {
          disclosure.open = false;
        }
      });
  });

  /* CERRAR SELECTOR CON ESC */

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('.mr-country-header__disclosure[open]')
      .forEach(function (disclosure) {
        disclosure.open = false;
        disclosure.querySelector('summary').focus();
      });
  });
  } catch(e) { console.error(e); }
})();

})();
